import { useT } from "../lib/i18n";

export function Personas() {
  const t = useT();
  const copy = t.personas;

  return (
    <section
      id="personas"
      className="border-t border-margin dark:border-paper/10 bg-margin/20 dark:bg-paper/[0.02]"
    >
      <div className="mx-auto max-w-6xl px-6 py-24">
        <div className="max-w-2xl">
          <p className="text-xs font-medium uppercase tracking-wider text-ink/50 dark:text-paper/50">
            {copy.label}
          </p>
          <h2 className="mt-2 font-display text-3xl sm:text-4xl font-semibold tracking-tight text-ink dark:text-paper">
            {copy.heading}
          </h2>
        </div>

        <div className="mt-16 grid gap-px overflow-hidden rounded-2xl border border-margin bg-margin sm:grid-cols-2 lg:grid-cols-3 dark:border-paper/10 dark:bg-paper/10">
          {copy.items.map((p) => (
            <div key={p.title} className="bg-paper p-6 dark:bg-ink">
              <h3 className="font-display text-lg font-semibold text-ink dark:text-paper">
                {p.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-ink/70 dark:text-paper/70">
                {p.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
